const LivenessStepIcon = ({ infillColor, strokeColor, iconColor }) => (
    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25.5" cy="25.5" r="24" fill={infillColor} stroke={strokeColor} strokeWidth="2"/>
        <svg viewBox="-40 -35 180 180">
            <g cx="50" cy="50">
                <path fill={iconColor} d="m92.4996338 79.8450089v15.1549911c0 1.3800049-1.1183243 2.5-2.4994202 2.5h-80.0004272c-1.3810959 0-2.4994192-1.1199951-2.4994192-2.5 0-4.4075012 0-10.7925034.0030308-15.1524963v-.0024948c0-3.6100006 1.1183233-7.132515 3.1991978-10.0850143 4.9927301-7.0299912 16.3044099-17.2599946 39.2974042-17.2599946s34.3046722 10.2300034 39.3004837 17.2599945c2.0808258 2.9500046 3.1991501 6.4750137 3.1991501 10.0850144z"/>
                <circle cx="50.001" cy="25" r="22.5" fill={iconColor}/>
            </g>
        </svg>
    </svg>);
export default LivenessStepIcon;